import { useEffect, useState } from "react";
import { Package, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

function fmt(n) {
  if (n == null) return null;
  if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  return String(n);
}

export default function PyPiBadge() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/pypi/stats")
      .then((r) => setData(r.data))
      .catch(() => setData({ version: "0.7.0", downloads_month: null }));
  }, []);

  const version = data?.version || "0.7.0";
  const dl = fmt(data?.downloads_month);
  const total = fmt(data?.downloads_total);

  return (
    <a
      href="https://pypi.org/project/upii/"
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3.5 py-2 font-mono text-[11px] text-mute transition-colors hover:border-ember/40 hover:text-paper"
      data-testid="pypi-badge"
    >
      <Package size={13} className="text-ember" />
      <span className="text-paper">upii</span>
      <span data-testid="pypi-version">v{version}</span>
      {dl && (
        <>
          <span className="text-white/20">·</span>
          <span data-testid="pypi-downloads">{dl}/mo</span>
        </>
      )}
      {total && (
        <>
          <span className="text-white/20">·</span>
          <span data-testid="pypi-total">{total} installs</span>
        </>
      )}
      <ArrowUpRight size={12} />
    </a>
  );
}
